<script setup lang="ts">
import { Button } from '../button';
import { Input } from '../input';

defineProps<{ placeholder: string; readonly: boolean; maxlength?: number; pattern?: string }>();

const list = defineModel<string[]>({ required: true });
</script>

<template>
  <div class="space-y-2">
    <!-- Show items in list -->
    <div v-for="(_item, listIndex) of list" :key="listIndex" class="flex flex-row items-center gap-2">
      <Input
        type="text"
        :placeholder
        v-model="list[listIndex]"
        :maxlength
        required
        :disabled="readonly"
        class="flex-1"
      />

      <Button v-if="!readonly" type="button" variant="destructive" size="sm" @click.prevent="list.splice(listIndex, 1)">
        <i class="fa-light fa-trash"></i>
      </Button>
    </div>

    <div>
      <span v-if="readonly && list.length === 0" class="block h-10 pt-3 text-slate-500 italic">None</span>
      <Button v-else-if="!readonly" type="button" variant="outline" size="sm" @click.prevent="list.push('')">
        <i class="fa-light fa-plus"></i>
        Add {{ placeholder?.replace(/\.\.\.$/, '') || 'Item' }}
      </Button>
    </div>
  </div>
</template>
